import React from 'react';
import { CircularProgress } from '@mui/material';
import Button from './editors/mui/Button';

class FileField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFile: null,
      isLoading: false,
    };

    this._handleFileSelected = this._handleFileSelected.bind(this);
  }

  render() {
    const { label, description, fileTypes, buttonType, buttonStyle, buttonLabelStyle } = this.props;
    const { selectedFile, isLoading } = this.state;

    const inputProps = {};
    const rootStyle = selectedFile ? { ...buttonStyle, backgroundColor: '#dfe8f0' } : buttonStyle;
    const labelStyle = selectedFile ? { ...buttonLabelStyle, color: '#6d7e8f' } : buttonLabelStyle;
    const buttonLabel = selectedFile ? 'Choose another file' : label ? label : 'Choose file';

    if (fileTypes) {
      inputProps.accept = fileTypes;
    }

    return (
      <div className="file-input-container">
        <div className="file-input-skin">
          {isLoading ? (
            <div
              style={{
                width: '100%',
                height: buttonStyle ? buttonStyle.height + 4 : '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <CircularProgress color="primary" size={24} />
            </div>
          ) : (
            <Button buttonTheme={buttonType ? buttonType : 'primary'} rootStyle={rootStyle}>
              <span style={labelStyle}>{buttonLabel}</span>
            </Button>
          )}
          {!isLoading && <input type="file" onChange={this._handleFileSelected} {...inputProps} />}
        </div>
        {selectedFile && <div className="file-name">Selected file: {selectedFile.name}</div>}
        {description && <div className="file-field-description">{description}</div>}
      </div>
    );
  }

  _handleFileSelected(event) {
    const { isBinary, onChange } = this.props;
    const file = event.target.files[0];

    if (!file) {
      this.setState({ selectedFile: null });
      onChange(null);
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      const encodedContent = isBinary ? content.substr(content.indexOf(',') + 1) : content;
      onChange(encodedContent);

      // show a spinner for at least 600ms
      setTimeout(() => this.setState({ isLoading: false }), 600);
    };

    this.setState({
      selectedFile: file,
      isLoading: true,
    });

    if (isBinary) {
      reader.readAsDataURL(file);
    } else {
      reader.readAsText(file);
    }
  }
}

FileField.defaultProps = {
  buttonLabelStyle: {},
  buttonStyle: {},
};

export default FileField;
